import { fetchJSON } from '@bonnet/next/fetch';

const directFraudReport = (data) => fetchJSON('/cars-for-sale/svc/leads/email/fraud', {
    body: data,
    method: 'POST',
});

export default (data) => directFraudReport(data);
